import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Translate } from "./Translator"

import { IsPhoneNumber } from "./GeneralFunctions"

const SearchField = (props) => {

    const [mSearchFilter, SetSearchFilter] = useState("")

    const Execute = (value) => {
        const trimmedValue = value.trim()
        if (IsPhoneNumber(trimmedValue))
        {
            props.OnMakeCall(trimmedValue)
        }
        else
        {
            props.OnSearchName(trimmedValue)
        }
    }

    return (
        <input autoComplete="new-password" placeholder={Translate("Type a name or number")} value={mSearchFilter} type="text" className="searchfield" onChange={(event) => { props.OnChanged(); SetSearchFilter(event.target.value) }} onKeyUp={(event) => { if (event.key === "Enter") { Execute(event.target.value)}}} />
    )
}

SearchField.propTypes = {
    OnChanged: PropTypes.func, 
    OnMakeCall: PropTypes.func,
    OnSearchName: PropTypes.func
  }

export default SearchField